import { generateStringFromAlphabet } from "@glide/support";

const firestoreCharacters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

export function generateFirestoreDocumentID(stringSize: number = 20): string {
    return generateStringFromAlphabet(stringSize, firestoreCharacters);
}
